import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/food',
    meta: {
        title: 'Healthy food | Child Poverty',
    },
    title: 'Healthy food',
    intro: oneLine`<b>174,000</b> children in New Zealand live in households that can’t always afford to put enough 
        healthy food on the table.`,
    image: {
        filename: 'Food.png',
        alt: '',
    },
    content: [
        oneLine`<p><b>56%</b> of children whose caregivers receive financial assistance are in households where there 
            is not always enough healthy food on the table, compared to just <b>12%</b> of children whose caregivers 
            do not receive financial assistance.</p>`,
    ],
};

export default data;
